<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Edit Profile Modal"
    seFeDataSubtitle="Display modal to edit and save profile changes"
    size="750">
  </se-fe-header>

  <div seFePageContent>
    <se-fe-card class="docs-card">
      <se-fe-card-header
        seFeDataTitle="Feature: Persona Image Avatar"
        seFeDataSubtitle="Modal to upload a persona's avatar image"
      ></se-fe-card-header>
      <se-fe-card-content>
        <p>Use in MySe Households or in other places where we need to update the persona's image.</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="docs-card">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-persona-image-modal-example></se-po-persona-image-modal-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
  </se-fe-page>
